// src/plugins/mapPlugin.js
import AMapLoader from "@amap/amap-jsapi-loader";

let AMapInstance = null;

const MapPlugin = {
    install(app) {
        app.config.globalProperties.$getAMap = async function (overWriteOptions) {
            if (!AMapInstance) {
                const basicOptions = {
                    key: "8a0f41fbdd3f3dbeeecfe8b3e62be87a"
                }
                if (overWriteOptions) {
                    basicOptions = { ...basicOptions, ...overWriteOptions }
                }
                AMapInstance = await AMapLoader.load(basicOptions);
            }
            return AMapInstance;
        };
    }
};

export default MapPlugin;